// HelpTip: a (?) beside a title or label that opens a short explanation (UX review, 30 Oct 2026: explanations sit
// behind a (?) rather than as text on the page). The text stays in the page, hidden until opened, so it is still found
// by search in the page and by screen readers that list it; Escape or a click elsewhere closes it.
import { useEffect, useId, useRef, useState, type ReactNode } from "react";
import { CircleHelp } from "lucide-react";

export function HelpTip({ label, children }: { label: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const box = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!open) return;
    const away = (e: PointerEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) setOpen(false);
    };
    const esc = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("pointerdown", away);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("pointerdown", away);
      document.removeEventListener("keydown", esc);
    };
  }, [open]);
  return (
    <span className="help-tip" ref={box}>
      <button type="button" className="help-tip-btn" aria-label={label} aria-expanded={open} aria-controls={id} onClick={() => setOpen((o) => !o)}>
        <CircleHelp size={18} strokeWidth={1.75} aria-hidden="true" focusable="false" />
      </button>
      <span id={id} className="help-tip-pop" hidden={!open}>
        {children}
      </span>
    </span>
  );
}
